import Box from "@mui/material/Box";
import isNil from "lodash/isNil";
import { useMemo } from "react";
import Htag from "../typography/Htag";
import Flx from "./Flx";
import ScreenContent from "./ScreenContent";

const TitledHeader = ({
  children,
  variant = "h2",
  sx,
  title,
  titleBottomContent,
  titleTopContent,
  titleContent,
  titleEndContent,
  titleStartContent,
  endContent,
  hideBottomBorder,
  borderColor = "#e0e0e0",
}) => {
  const styles = useMemo(() => {
    return {
      display: "flex",
      background: "#ffffff",
      flexDirection: "column",
      // borderBottom: hideBottomBorder ? "none" : "1px solid #eeeeee",
      borderBottom: hideBottomBorder ? "none" : `1px solid ${borderColor}`,
      ...sx,
    };
  }, [sx, hideBottomBorder, borderColor]);
  return (
    <>
      <ScreenContent sx={styles}>
        <Flx fw jb ac>
          <TitleContent
            title={title}
            titleBottomContent={titleBottomContent}
            titleTopContent={titleTopContent}
            titleContent={titleContent}
            titleEndContent={titleEndContent}
            titleStartContent={titleStartContent}
            variant={variant}
          />
          {endContent}
        </Flx>
        {isNil(children) ? null : <Box>{children}</Box>}
      </ScreenContent>
    </>
  );
};

const TitleContent = ({
  titleStartContent,
  titleEndContent,
  variant,
  title,
  titleTopContent,
  titleBottomContent,
  titleContent,
}) => {
  if (titleContent) {
    return titleContent;
  }

  // if (titleStartContent || titleEndContent) {
  //   return (
  //     <Flx ac gap={1}>
  //       {titleStartContent}
  //       <Title variant={variant}>{title}</Title>
  //       {titleEndContent}
  //     </Flx>
  //   );
  // }

  if (
    titleTopContent ||
    titleBottomContent ||
    titleStartContent ||
    titleEndContent
  ) {
    return (
      <Flx column gap={1}>
        {titleTopContent}
        <Flx ac gap={1}>
          {titleStartContent}
          <Title variant={variant}>{title}</Title>
          {titleEndContent}
        </Flx>
        {titleBottomContent}
      </Flx>
    );
  }
  return <Title variant={variant}>{title}</Title>;
};
const Title = ({ variant, children, title }) => {
  return <Htag variant={variant}>{children}</Htag>;
};
export default TitledHeader;
